module.exports = __webpack_public_path__ + "media/10.b31d9895.mp3";